<template>
  <div class="environments mt15">
    <img
      class="mb10"
      :src="`${userCommonImageUrlForSp}/company_data_sp.png`"
      alt="environments"
      width="125"
    >
    <h3 class="fs14 fwB">
      データで見る働く環境
    </h3>
    <p class="fs11 tr mt5">
      {{ updateDate | formatDate }}時点
    </p>
    <slot />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import dayjs from 'dayjs'
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  filters: {
    formatDate (date) {
      return date ? dayjs(date).format('YYYY年MM月') : ''
    }
  },
  mixins: [jobPreviewCommon],
  props: {
    updateDate: {
      type: String,
      required: true
    }
  }
}
</script>
